import paletteEngine from "./paletteEngine"
//custom styles for react-select dropdown menus
const selectMenuStyles = {
    clearIndicator: (base) => ({
        ...base,
        color: `${paletteEngine.getPaletteColor("formXIconColor")}`
    }),
    // container: (base) => ({
    //     ...base
    // }),
    control: (base) => ({
        ...base,
        height: "38px",
        overflowY: "auto",
        backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`,
        color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
    }),
    // dropdownIndicator: (base) => ({
    //     ...base
    // }),
    // group: (base) => ({
    //     ...base
    // }),
    // groupHeading: (base) => ({
    //     ...base
    // }),
    // indicatorsContainer: (base) => ({
    //     ...base
    // }),
    // indicatorSeparator: (base) => ({
    //     ...base,
    // }),
    // input: (base) => ({
    //     ...base
    // }),
    // loadingIndicator: (base) => ({
    //     ...base
    // }),
    // loadingMessage: (base) => ({
    //     ...base
    // }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
        backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`,
        color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
    }),
    menuList: (base) => ({
        ...base,
        backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`,
        color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999
    }),
    multiValue: (base) => ({
        ...base,
        color: `${paletteEngine.getPaletteColor("formXIconColor")}`
    }),
    multiValueLabel: (base) => ({
        ...base,
        backgroundColor: `${paletteEngine.getPaletteColor("multiValueLabelBackgroundColor")}`,
        color: `${paletteEngine.getPaletteColor("multiValueLabelColor")}`
    }),
    multiValueRemove: (base) => ({
        ...base,
        backgroundColor: `${paletteEngine.getPaletteColor("multiValueLabelBackgroundColor")}`,
        color: `${paletteEngine.getPaletteColor("formXIconColor")}`
    }),
    // noOptionsMessage: (base) => ({
    //     ...base
    // }),
    // option: (base) => ({
    //     ...base
    // }),
    // placeholder: (base) => ({
    //     ...base
    // }),
    singleValue: (base) => ({
        ...base,
        color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
    }),
    // valueContainer: (base) => ({
    //     ...base
    // })
}

export default selectMenuStyles